import globalConfig from './config';

export const DebugLog = {
  log(message: string, extra?: any): void {
    try {
      if (isDebugLogEnabled()) {
        console.log(
          getOguryLog + formatVersion + `%c ${message}`,
          bgOguryLog,
          bgFormatVersion,
          '',
          extra
        );
      }
    } catch (_) {
      // Do nothing
    }
  }
};

const getOguryLog = '%c OGURY ';
const bgOguryLog =
  'background:#005959;color:#ffffff;font-weight:bold;border-radius:3px;';
const bgFormatVersion =
  'background:#C3EA76;color:#005959;font-weight:bold;border-radius:3px;padding:1px;margin-left:1px;margin-left:1px;padding-left:3px;padding-right:3px';
const formatVersion = `%c format-legacy-${globalConfig.COMMIT_HASH}`;

function getQueryParams(url: string, name: string): string | null {
  if (!url) return null;
  const value = url.match(new RegExp('.*[?&]' + name + '=([^&#]*)'));
  return value && value[1] ? value[1] : null;
}

function getTopWindow(): Window | null {
  try {
    return window.top;
  } catch (e) {
    return null;
  }
}

function getLocation(): string | undefined {
  try {
    // get location from the tag if it's available
    if (
      window.parent &&
      (window.parent as any).ogTop &&
      (window.parent as any).ogTop.OG_TOP_CONTEXT
    ) {
      return (window.parent as any).ogTop.OG_TOP_CONTEXT.locationResolved;
    }

    const topWindow: any = getTopWindow();
    if (topWindow) {
      return topWindow.location.href;
    }

    return window.location.href;
  } catch (_) {
    return undefined;
  }
}

function isDebugLogEnabled(): boolean {
  if ((window as any).ogy_log === 'debug') {
    return true;
  }
  const location = getLocation();
  if (location) {
    return getQueryParams(location, 'ogy_log') === 'debug';
  }
  return false;
}
